import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom'

export class StocktakeTasks extends Component {
    static displayName = StocktakeTasks.name;

    constructor(props) {
        super(props);
        this.state = { selectedStock: [], loading: true, previouspage: "StocktakeTasks" };
        this.history = props.history;
        if (this.props.location && this.props.location.state) {

            var selectedStock = this.props.location.state;
            this.state = selectedStock;
        }
    }

    componentDidMount() {
    }
    goto(page) {
        this.history.push(page);
    }

    render() {
        return (

            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h5>Select a Task</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('SelectStocktake'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>

                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "FirstCount/FirstCount_Location", state: this.state }}>First Count</Link>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "Recount/Recount_Location", state: this.state }}>Recount</Link>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "AdhocCount/AdhocCount_Location", state: this.state }}>Adhoc Count</Link>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "AddNew/AddNew_ProductLocation", state: this.state }}>Add Extra</Link>


                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
